// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-form {
   margin: 0;
   padding: 0;
   display: flex;
   position: relative;
}

.search-form input {
   background: #fff;
   border: 1px solid #ccc;
   border-radius: 30px;
   outline: none;
   line-height: 30px;
   padding: 0 8px 0 30px;
   width: 100%;
   max-width: 300px;
   height: 30px;
   transition: max-width .2s ease-in-out;
}

.search-form input:focus {
   max-width: 360px;
}

.search-form input::-webkit-input-placeholder {
   color: #999;
}

.search-form input:focus::-webkit-input-placeholder {
   color: #ccc;
}

.search-form input::-moz-placeholder {
   color: #999;
}

.search-form input:focus::-moz-placeholder {
   color: #ccc;
}

.search-form .fa-search {
   background: transparent;
   color: #aaa;
   font-size: 16px;
   border: none;
   outline: none;
   padding: 0;
   position: absolute;
   left: 0;
   top: 0;
   width: 30px;
   height: 30px;
}

.search-form .fa-search:before {
   position: absolute;
   top: 6px;
   left: 9px;
}

.live-search {
   background-color: #fff;
   box-sizing: border-box;
   box-shadow: 0 5px 12px 2px rgba(0, 0, 0, 0.25);
   margin-top: 5px;
   position: absolute;
   width: 360px;
}

.live-search ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.live-search a {
   cursor: pointer;
   padding: 10px;
}

.live-search a:hover {
   background-color: #f4f5f7;
   text-decoration: none;
}

.live-search img {
   margin-right: 10px;
   object-fit: cover;
   min-width: 32px;
   width: 32px;
   height: 32px;
}

.live-search .name, .live-search .desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

.live-search .desc {
   color: #999;
   font-size: 12px;
}

.live-search .not-found {
   padding: 10px 20px;
}
.search-select{
   max-height: 200px;
   overflow-y: auto;
   position: fixed!important;
   z-index: 1!important;
}
.cannot{
   color: #a7a6a6;
   cursor:default;
}
.clear-button{
   margin: 0 0 0 10px;
   max-width: 30%;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/search-box/search-box.component.css"],"names":[],"mappings":"AAAA;GACG,SAAS;GACT,UAAU;GACV,aAAa;GACb,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,sBAAsB;GACtB,mBAAmB;GACnB,aAAa;GACb,iBAAiB;GACjB,qBAAqB;GACrB,WAAW;GACX,gBAAgB;GAChB,YAAY;GACZ,qCAAqC;AACxC;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,uBAAuB;GACvB,WAAW;GACX,eAAe;GACf,YAAY;GACZ,aAAa;GACb,UAAU;GACV,kBAAkB;GAClB,OAAO;GACP,MAAM;GACN,WAAW;GACX,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,sBAAsB;GACtB,sBAAsB;GACtB,8CAA8C;GAC9C,eAAe;GACf,kBAAkB;GAClB,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,eAAe;GACf,aAAa;AAChB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,kBAAkB;GAClB,iBAAiB;GACjB,eAAe;GACf,WAAW;GACX,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,kBAAkB;AACrB;AACA;GACG,iBAAiB;GACjB,gBAAgB;GAChB,yBAAyB;GACzB,oBAAoB;AACvB;AACA;GACG,cAAc;GACd,cAAc;AACjB;AACA;GACG,kBAAkB;GAClB,cAAc;AACjB","sourcesContent":[".search-form {\n   margin: 0;\n   padding: 0;\n   display: flex;\n   position: relative;\n}\n\n.search-form input {\n   background: #fff;\n   border: 1px solid #ccc;\n   border-radius: 30px;\n   outline: none;\n   line-height: 30px;\n   padding: 0 8px 0 30px;\n   width: 100%;\n   max-width: 300px;\n   height: 30px;\n   transition: max-width .2s ease-in-out;\n}\n\n.search-form input:focus {\n   max-width: 360px;\n}\n\n.search-form input::-webkit-input-placeholder {\n   color: #999;\n}\n\n.search-form input:focus::-webkit-input-placeholder {\n   color: #ccc;\n}\n\n.search-form input::-moz-placeholder {\n   color: #999;\n}\n\n.search-form input:focus::-moz-placeholder {\n   color: #ccc;\n}\n\n.search-form .fa-search {\n   background: transparent;\n   color: #aaa;\n   font-size: 16px;\n   border: none;\n   outline: none;\n   padding: 0;\n   position: absolute;\n   left: 0;\n   top: 0;\n   width: 30px;\n   height: 30px;\n}\n\n.search-form .fa-search:before {\n   position: absolute;\n   top: 6px;\n   left: 9px;\n}\n\n.live-search {\n   background-color: #fff;\n   box-sizing: border-box;\n   box-shadow: 0 5px 12px 2px rgba(0, 0, 0, 0.25);\n   margin-top: 5px;\n   position: absolute;\n   width: 360px;\n}\n\n.live-search ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.live-search a {\n   cursor: pointer;\n   padding: 10px;\n}\n\n.live-search a:hover {\n   background-color: #f4f5f7;\n   text-decoration: none;\n}\n\n.live-search img {\n   margin-right: 10px;\n   object-fit: cover;\n   min-width: 32px;\n   width: 32px;\n   height: 32px;\n}\n\n.live-search .name, .live-search .desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n\n.live-search .desc {\n   color: #999;\n   font-size: 12px;\n}\n\n.live-search .not-found {\n   padding: 10px 20px;\n}\n.search-select{\n   max-height: 200px;\n   overflow-y: auto;\n   position: fixed!important;\n   z-index: 1!important;\n}\n.cannot{\n   color: #a7a6a6;\n   cursor:default;\n}\n.clear-button{\n   margin: 0 0 0 10px;\n   max-width: 30%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
